import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader, StatusChip } from "./primitives";
import Countdown from "./Countdown";
import { PRESALE_STATUS_LABELS } from "@/config/jovino";

const RESERVED = [
  ["Presale Price", "price"],
  ["Presale Allocation", "allocation"],
  ["Hard Cap", "hardCap"],
  ["Soft Cap", "softCap"],
  ["Payment Currency", "paymentCurrency"],
  ["Minimum Purchase", "minPurchase"],
  ["Maximum Purchase", "maxPurchase"],
];

const Presale = () => {
  const config = useSiteConfig();
  const p = config.presale;
  const statusLabel = PRESALE_STATUS_LABELS[p.status] || PRESALE_STATUS_LABELS.upcoming;

  return (
    <section id="presale" className="relative py-24 lg:py-36 border-t border-line overflow-hidden" data-testid="presale-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(214,181,106,0.05),transparent_55%)]" aria-hidden="true" />
      <div className="section-shell relative">
        <SectionHeader
          index={15}
          eyebrow="Presale"
          title="The JCV Presale"
          align="center"
          testId="presale-header"
        />

        <Reveal delay={0.1} className="mt-12 text-center">
          <div className="font-mono text-xs tracking-[0.4em] uppercase text-slate">Presale Begins</div>
          <div className="mt-3 gold-number font-semibold text-3xl sm:text-5xl lg:text-6xl" data-testid="presale-date">
            1 November 2026
          </div>
        </Reveal>

        <Reveal delay={0.2} className="mt-12 max-w-2xl mx-auto">
          <Countdown target={p.startDateISO} status={p.status} />
        </Reveal>

        <Reveal delay={0.3} className="mt-12 text-center">
          <StatusChip tone="gold" testId="presale-status-chip">{statusLabel}</StatusChip>
          <p className="mt-6 mx-auto max-w-2xl text-sm sm:text-base text-slate leading-relaxed" data-testid="presale-copy">
            Detailed presale mechanics, pricing, allocation, participation requirements and purchase information will be
            announced in a future version of the Jovino Coin documentation.
          </p>
        </Reveal>

        <Reveal delay={0.4} className="mt-12 max-w-3xl mx-auto">
          <div className="card-surface rounded-xl divide-y divide-line" data-testid="presale-parameters">
            {RESERVED.map(([label, key]) => (
              <div key={key} className="flex items-center justify-between gap-6 px-6 sm:px-8 py-4">
                <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-slate">{label}</span>
                <span className="font-mono text-xs sm:text-sm text-slate/80" data-testid={`presale-param-${key}`}>
                  {p[key] ?? "To Be Announced"}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Presale;
